/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Модель для формы запроса денежных средств
   */
  app.RefundRequest = app.Model.extend({
    urlRoot: app.newRefundRequestUrl,
    requestParameters: { is_test: 'f' },
  });
})();

}.call(window));